import type { AnyAction } from 'redux'

import type { SignalRAction } from '../../signalR'

export function checkStatus(
  status: string,
): asserts status is 'Progress' | 'Failed' | 'Aborted' | 'Done' | 'Pending' {
  switch (status) {
    case 'Progress':
    case 'Failed':
    case 'Aborted':
    case 'Done':
    case 'Pending':
      return
    default:
      throw new Error(`Status ${status} is not valid`)
  }
}

export function checkStatusSeismic(
  status: string,
): asserts status is 'Failed' | 'Done' | 'Pending' | 'Running' {
  switch (status) {
    case 'Failed':
    case 'Done':
    case 'Pending':
    case 'Running':
      return
    default:
      throw new Error(`Status ${status} is not valid`)
  }
}

export function checkPoolNames(name: string): asserts name is 'GeoImport' | 'GridCalc' | 'MlCalc' {
  switch (name) {
    case 'GeoImport':
    case 'GridCalc':
    case 'MlCalc':
      return
    default:
      throw new Error(`name ${name} is not valid`)
  }
}

export const isSignalRAction = (
  candidate: AnyAction,
): candidate is SignalRAction<Record<string, unknown[]>> =>
  typeof candidate.type === 'string' && candidate.type.startsWith('signalR/')
